var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.283 3.501L6.51005 11.475C6.37352 11.6151 6.29712 11.8029 6.29712 11.9985C6.29712 12.1941 6.37352 12.3819 6.51005 12.522L14.283 20.499C14.3466 20.5643 14.4227 20.6162 14.5067 20.6517C14.5906 20.6871 14.6809 20.7054 14.772 20.7054C14.8632 20.7054 14.9534 20.6871 15.0374 20.6517C15.1214 20.6162 15.1975 20.5643 15.261 20.499C15.3919 20.365 15.4651 20.1852 15.4651 19.998C15.4651 19.8107 15.3919 19.6309 15.261 19.497L7.95155 11.9985L15.261 4.5015C15.3914 4.36762 15.4644 4.18813 15.4644 4.00125C15.4644 3.81437 15.3914 3.63488 15.261 3.501C15.1975 3.43569 15.1214 3.38377 15.0374 3.34833C14.9534 3.31288 14.8632 3.29462 14.772 3.29462C14.6809 3.29462 14.5906 3.31288 14.5067 3.34833C14.4227 3.38377 14.3466 3.43569 14.283 3.501V3.501Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.94c01c1e787dfbeff19a761b6e710b61.svg";
export { ForwardRef as ReactComponent };